exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/setor/modal-ponto-fisico-setor/modal-ponto-fisico-setor.component.css
// module id = ../../../../../src/app/setor/modal-ponto-fisico-setor/modal-ponto-fisico-setor.component.css
// module chunks = main